import React, { useState, useEffect } from 'react'

const LOGO = 'https://cdn2.schedpilot.com/files/logo.png'

const BACKGROUNDS = [
  'https://cdn2.schedpilot.com/files/stefan-stefancik-pzA7QWNCIYg-unsplash-scaled-e1780569793213.jpg',
  'https://cdn2.schedpilot.com/files/annie-spratt-vGgn0xLdy8s-unsplash-scaled-e1780570222771.jpg',
  'https://cdn2.schedpilot.com/files/anna-barsukova-rtpX6teXLsM-unsplash.jpg',
  'https://cdn2.schedpilot.com/files/voyage-pro-nXkuAN6XD40-unsplash.jpg',
  // add more URLs here
]

export default function AuthLayout({ children }) {
  const [currentBg, setCurrentBg] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => setCurrentBg(i => (i + 1) % BACKGROUNDS.length), 5000)
    return () => clearInterval(timer)
  }, [])

  return (
    <div style={{ minHeight: '100vh', position: 'relative', display: 'flex', flexDirection: 'column', background: '#000', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>

      {/* ── Background layers (crossfade) ── */}
      {BACKGROUNDS.map((url, i) => (
        <div key={i} style={{
          position: 'absolute', inset: 0, zIndex: 0,
          backgroundImage: `linear-gradient(rgba(0,0,0,0.72), rgba(0,0,0,0.72)), url(${url})`,
          backgroundSize: 'cover', backgroundPosition: 'center',
          opacity: i === currentBg ? 1 : 0,
          transition: 'opacity 1.5s ease-in-out',
        }} />
      ))}

      {/* ── Top nav ── */}
      <nav style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 32px', height: 60,
        background: '#fff', borderBottom: '1px solid #e2e8f0',
        position: 'sticky', top: 0, zIndex: 10,
        isolation: 'isolate',
      }}>
        <a href="https://schedpilot.com" style={{ display: 'flex', alignItems: 'center', gap: 9, textDecoration: 'none' }}>
          <img src={LOGO} alt="SchedPilot" style={{ width: 28, height: 28 }} />
          <span style={{ fontSize: '1.05rem', fontWeight: 700, color: '#0f172a', letterSpacing: '-0.01em' }}>SchedPilot</span>
        </a>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <a
            href="https://schedpilot.com"
            style={{ padding: '6px 14px', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, color: '#475569', textDecoration: 'none' }}
            onMouseOver={e => e.currentTarget.style.background = '#f1f5f9'}
            onMouseOut={e => e.currentTarget.style.background = 'transparent'}
          >
            Home
          </a>
          <a
            href="/onboarding-flow"
            style={{ padding: '7px 18px', borderRadius: 8, background: '#2fba01', color: '#fff', textDecoration: 'none', fontSize: '0.875rem', fontWeight: 600 }}
          >
            Sign up free
          </a>
        </div>
      </nav>

      {/* ── Page body ── */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', padding: '32px 16px', position: 'relative', zIndex: 1 }}>

        {/* Card */}
        <div className="ob-card" style={{ background: '#fff', borderRadius: 20, border: '1px solid #e2e8f0', boxShadow: '0 8px 40px rgba(0,0,0,0.08)', width: '100%', maxWidth: 460, padding: '36px 40px' }}>
          {children}
        </div>

        <p className="ob-card-footer" style={{ marginTop: 20, fontSize: '0.75rem', color: '#94a3b8', textAlign: 'center', width: '100%', maxWidth: 460 }}>
          By continuing you agree to SchedPilot's{' '}
          <a href="https://schedpilot.com/terms" style={{ color: '#64748b' }}>Terms</a>
          {' '}and{' '}
          <a href="https://schedpilot.com/privacy" style={{ color: '#64748b' }}>Privacy Policy</a>
        </p>
      </div>

      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @media (min-width: 769px) { .ob-card, .ob-card-footer { margin-left: 84px; } }
        input:focus { border-color: #2fba01 !important; box-shadow: 0 0 0 3px rgba(47,186,1,0.12); }
      `}</style>
    </div>
  )
}
